<template>
  <modal :name="name" height="auto" @before-open="beforeOpen">
    <div class="col-sm-12" style="display:inline-block;">
      <div class="form-group" style="padding-top: 12px">
        <h4 class="card-title">{{ header }}</h4>
      </div>

      <div class="card-body form">
        <div class="row">
          <div class="col-6">
            <div class="form-group" :class="error('description')">
              <label for="description">Description</label>
              <input autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
                type="text"
                id="description"
                name="description"
                v-model="unit.description"
                class="form-control"
                v-validate="'required'"
                @keyup="productLiveSearch(unit.description)"
              />
              <div :id="`productCustomLiveSearch`" class="customLiveSearch" style="max-height: 250px;">
                <template v-for="(product, pIdx) in productrows">
                  <div :key="pIdx" class="customLiveSearchElement" v-on:click="productSelected(product)">{{ product }}</div>
                </template>
              </div>
            </div>
          </div>
          <div v-show="level === 2" class="col-6">
            <div class="form-group">
              <label for="includeInTransferOrder">Incl. w/ Transfer Order</label>
              <select class="form-control" v-model.number="unit.includeInTransferOrder" id="includeInTransferOrder">
                <option :value=true >Yes</option>
                <option :value=false >No</option>
              </select>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group" :class="error('quantity')">
              <label for="quantity">Quantity</label>
              <input
                class="form-control"
                type="number"
                autocomplete="off"
                id="quantity"
                name="quantity"
                v-model.number="unit.quantity"
                min="1"
                v-validate="'required|decimal:0|min_value:1'"
                @blur="getLotNumbers(unit.internalId, unit.quantity);"
              />

            </div>
          </div>
          <div v-show="level === 2" class="col-9">
            <div class="form-group" :class="error('lot')">
              <label for="lot">Lot # <small>{{this.unit.lot ? this.unit.lot + " " + this.unit.available : ""}}</small></label>
              <input
                class="form-control"
                type="text"
                autocomplete="off"
                id="lot"
                name="lot"
                v-model="unit.lot"
                :disabled="fullLotList.length == 0"
                @keyup="lotLiveSearch(unit.lot)"
                v-on:click="showLots()"
              />
              <div :id="`lotCustomLiveSearch`" class="customLiveSearch" style="max-height: 250px;" v-if="fullLotList.length > 0">
                <template v-for="(lot, lIdx) in lotRows">
                  <div :key="lIdx" class="customLiveSearchElement" v-on:click="lotSelected(lot)">{{ lot.name + ' (' + lot.available + ')' }}</div>
                </template>
              </div>
            </div>
          </div>

          <div class="col-12">
            <v-error :err="errors" id="description"/>
            <v-error :err="errors" id="quantity"/>
          </div>
        </div>


        <div class="row">
          <div class="col-3">
            <div class="form-group" :class="error('length')">
              <label for="length">Length</label>
              <input
                class="form-control"
                type="number"
                id="length"
                name="length"
                v-model.number="unit.length"
                min="0.001"
                max="1000"
                v-validate="'required|min_value:0.001|max_value:1000'"
              />
            </div>
          </div>
          <div class="col-3">
            <div class="form-group" :class="error('width')">
              <label for="width">Width</label>
              <input
                class="form-control"
                type="number"
                id="width"
                name="width"
                v-model.number="unit.width"
                min="0.001"
                max="1000"
                v-validate="'required|min_value:0.001|max_value:1000'"
              />
            </div>
          </div>
          <div class="col-3">
            <div class="form-group" :class="error('height')">
              <label for="height">Height</label>
              <input
                class="form-control"
                type="number"
                id="height"
                name="height"
                v-model.number="unit.height"
                min="0.001"
                max="1000"
                v-validate="'required|min_value:0.001|max_value:1000'"
              />
            </div>
          </div>
          <div class="col-3">
            <div class="form-group" :class="error('dimensionunit')">
              <label for="dimensionunit">Unit</label>
              <select class="form-control" v-model.number="unit.dimensionunit" id="dimensionunit">
                <option :value=4 >Inches</option>
                <option :value=3 >Feet</option>
                <option :value=2 >Centimeters</option>
                <option :value=1 >Meters</option>
              </select>
            </div>
          </div>
          <div class="col-12">
            <v-error :err="errors" id="length"/>
            <v-error :err="errors" id="width"/>
            <v-error :err="errors" id="height"/>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="form-group" :class="error('weight')">
              <label for="weight">Weight</label>
              <div class="input-group">
                <input
                  class="form-control"
                  type="number"
                  id="weight"
                  name="weight"
                  v-model.number="unit.weight"
                  min="0.001"
                  max="10000"
                  v-validate="'required|min_value:0.001|max_value:10000'"
                />
                <span class="input-group-addon su-group-addon">per unit</span>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group" :class="error('weight')">
              <label for="weightunit">Unit</label>
              <select class="form-control" v-model.number="unit.weightunit" id="weightunit">
                <option :value=2 >Lb</option>
                <option :value=1 >Kg</option>
              </select>
            </div>
          </div>
          <div class="col-12">
            <v-error :err="errors" id="weight"/>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <!-- <p v-show="errors.has('deliverydate')" class="help is-danger">{{ errors.first('deliverydate') }}</p> -->
          </div>
          <div class="col-sm-6">
            <div class="form-group form-actions float-right" style="margin-bottom: 16px">
              <button type="button" class="btn btn-default" @click="hide">Cancel</button>
              <button class="btn btn-success btn-wd" @click="save">Done</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>


<script>
import ErrorMsg from "../ErrorMsg";
import apiService from '../../services/api.service'

var productrows = [];
var fullLotList = [];
var lotRows = [];

const defaultUnit = () => ({
  internalId: "",
  description: "",
  quantity: 1,
  length: 1,
  width: 1,
  height: 1,
  dimensionunit: 4,
  weight: 1,
  weightunit: 2,
  lot: '',
  components: [],
  includeInTransferOrder: false,
});

const copyAtoB = (a, b) => {
  b.internalId = a.internalId;
  b.description = a.description;
  b.type = a.type;
  b.quantity = a.quantity;
  b.length = a.length;
  b.width = a.width;
  b.height = a.height;
  b.dimensionunit = a.dimensionunit;
  b.weight = a.weight;
  b.weightunit = a.weightunit;
  b.lot = a.lot;
  b.includeInTransferOrder = a.includeInTransferOrder;
  b.internalId = a.internalId;
}

export default {
  name: 'ShippingLvlModal',
  components: {
    'v-error': ErrorMsg
  },
  data: function () {
    return {
      name: "shipping-lvl-modal",
      level: 3,
      parent: null,
      toUpdate: null,
      unit: defaultUnit(),
      productrows: productrows,
      lotRows: lotRows,
      fullLotList,
      liveSearching: false,
    }
  },
  computed: {
    deliveryDateTime() {
      return newSafeDate(this.deliveryDate);
    },
    header() {
      let shipLevel;
      switch(this.level) {
        case 1:
          shipLevel = "Primary";
          break;
        case 2:
          shipLevel = "Secondary";
          break;
        default:
          shipLevel = "Tertiary";
      }
      return `Ship Level - ${shipLevel}`;
    }
  },
  methods: {
    beforeOpen(e) {
      this.parent = e.params.parent;
      this.level = e.params.level ? e.params.level : 3;
      if(e.params.component) {
        this.toUpdate = e.params.component;
        copyAtoB(this.toUpdate, this.unit);
      }

      if (this.parent && !this.unit.description) {
        this.unit.description = this.parent.sudescription;
        this.productSelected(this.unit.description);
      }

      // Detect when escape is pressed
      const keyFunction = (evt) => {
        if (evt.code === 'Escape') { 
            console.log('escape pressed');
            this.hide();
            document.removeEventListener('keyup');
        }
      }
      this.populateLotNumbers()
      document.addEventListener('keyup', keyFunction);
    },
    error(id) {
      return {
        'has-error':this.errors.has(id)
      };
    },
    hide() {
      this.unit = defaultUnit();
      this.parent = null;
      this.toUpdate = null;
      this.$modal.hide(this.name);
    },
    async save() {
      await this.$validator.validateAll();

      if (this.errors.any()) return;

      if(this.toUpdate) {
        copyAtoB(this.unit, this.toUpdate);
      } else if(Array.isArray(this.parent.components)) {
        this.parent.components.push(this.unit);
      }
      this.hide();

      // Reload shipping summary
      this.$parent.loadShippingSummary({rfq: this.rfq, rows: this.rows});
    },
    productLiveSearch: async function (text) {
      console.log("product search deprecated");
    },
    productSelected: async function (product) {
      console.log('productSelected deprecated');
    },
    populateLotNumbers: async function() {
    },
    showLots: function() {
      // show onClick of input
      this.liveSearching = true;
      this.showAutoComplete(`lotCustomLiveSearch`);
    },
    lotLiveSearch: async function (text) {
      // only filter when text is valid
      if (text.length > 0) {
        // refresh the list
        this.dissmissAutoCompletes();
        console.log("lot search " + text);
        console.log("lotLiveSearch");
        this.liveSearching = true;
        // filter from full list
        if (this.fullLotList) {
          this.lotRows = this.fullLotList.filter(row => row.name.includes(text));
        }
        this.showAutoComplete(`lotCustomLiveSearch`);
      }
    },
    lotSelected: function (lot) {
      console.log('lotSelected ' + JSON.stringify(lot));
      this.liveSearching = false;
      this.dissmissAutoCompletes();
      if(lot) {
          this.unit.lot = lot.name;
          this.unit.available = lot.available;
      }
    },
    getLotNumbers: async function (internalId, quantity) {
      this.dissmissAutoCompletes();
      console.log("lot search " + internalId + " " + quantity);
      this.lotRows = [];
      this.fullLotList = [];
      
      //first get all possible lot numbers
      let lotRows = null;
      await apiService.get('/netsuite/getLotNumbers/' + internalId)
      .then(function (response) {
        lotRows = response.data.Result;
      });

      // then get all lot numbers with available stock...
      var lots = {};
      try {
        await apiService.get(`/netsuite/getLotNumbers/${internalId}?numItemsRequested=${quantity}`)
        .then(function (response) {
          for (let i = 0; i < response.data.Result.length; i++) {
            lots[response.data.Result[i]] = true;
          }
        });
      } catch (e) {
        console.log('getLotNumbers', e);
      }

      // ...and combine info into one array
      let selectedLot = null;
      for (let i = 0; i < lotRows.length; i++) {
        lotRows[i] = { name: lotRows[i], available: lots[lotRows[i]] ? "available" : "not available" };
        if (lotRows[i].name == this.unit.lot) {
          selectedLot = lotRows[i];
        }
      }
      this.lotSelected(selectedLot);
      this.lotRows = lotRows;
      this.fullLotList = lotRows;
    },
    dissmissAutoCompletes: function() {
      console.log("dissmissAutoCompletes");
      $(".customLiveSearch").hide();
    },

    showAutoComplete: function(id) {
      if(!this.liveSearching) return;
      document.getElementById(id).style.display = 'block';
    },
  }
}
</script>

<style scoped>
.su-group-addon {
  background-color: #eee !important;
  border: 1px solid #ccc !important;
}
.customLiveSearch {
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// ShippingLvlModal.vue?23d56088